export default "__VITE_ASSET__B_28kvsA__"